import { useState } from "react";

const SECTIONS = [
  { id: "acceso", title: "1. Acceso al Sistema", icon: "ri-login-box-line" },
  { id: "navegacion", title: "2. Navegacion General", icon: "ri-compass-3-line" },
  { id: "operaciones", title: "3. Operaciones Basicas", icon: "ri-tools-line" },
  { id: "noticias", title: "4. Noticias", icon: "ri-newspaper-line" },
  { id: "citas", title: "5. Citas y Testimonios", icon: "ri-double-quotes-l" },
  { id: "documentos", title: "6. Documentos", icon: "ri-file-list-line" },
  { id: "equipo", title: "7. Equipo", icon: "ri-team-line" },
  { id: "heroes", title: "8. Heroes (Banners)", icon: "ri-image-line" },
  { id: "timeline", title: "9. Linea de Tiempo", icon: "ri-time-line" },
  { id: "footer", title: "10. Footer", icon: "ri-layout-bottom-line" },
  { id: "footer_links", title: "11. Enlaces del Footer", icon: "ri-links-line" },
  { id: "redes", title: "12. Redes Sociales", icon: "ri-share-line" },
  { id: "comunas", title: "13. Comunas", icon: "ri-map-pin-line" },
  { id: "indicadores", title: "14. Indicadores", icon: "ri-pie-chart-line" },
  { id: "vision", title: "15. Vision y Mision", icon: "ri-eye-line" },
  { id: "objetivos", title: "16. Objetivos", icon: "ri-flag-line" },
  { id: "especialistas", title: "17. Especialistas", icon: "ri-user-star-line" },
  { id: "evidencias", title: "18. Filtros de Evidencias", icon: "ri-filter-3-line" },
  { id: "etapas", title: "19. Etapas del Estudio", icon: "ri-stack-line" },
  { id: "paginas", title: "20. Paginas: Inicio y La Region", icon: "ri-pages-line" },
  { id: "problemas", title: "21. Solucion de Problemas", icon: "ri-question-line" },
];

export default function AdminManual() {
  const [activeSection, setActiveSection] = useState("acceso");

  return (
    <div className="min-h-screen bg-masmed-gray-50">
      {/* Top bar */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-40 print:hidden">
        <div className="w-full px-6 md:px-10 lg:px-16 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center">
              <i className="ri-book-open-line text-white text-lg"></i>
            </div>
            <div>
              <h1 className="text-base font-bold text-gray-900" style={{ fontFamily: "'Utendo', 'Arial', sans-serif" }}>
                Manual de Usuario
              </h1>
              <p className="text-xs text-gray-500">Panel de Administracion</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="/admin"
              className="px-4 py-2 rounded-lg border border-gray-200 text-sm text-gray-600 hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-1.5" />
              Volver al Panel
            </a>
            <button
              onClick={() => window.print()}
              className="px-5 py-2 rounded-lg bg-primary text-white text-sm font-medium hover:bg-primary-dark transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-download-line mr-1.5" />
              Descargar PDF
            </button>
          </div>
        </div>
      </div>

      <div className="w-full max-w-[1200px] mx-auto px-6 md:px-10 lg:px-16 py-8">
        <div className="flex gap-8">
          {/* Sidebar */}
          <aside className="hidden lg:block w-64 flex-shrink-0">
            <div className="sticky top-24 border border-gray-200 rounded-xl bg-white overflow-hidden">
              <div className="p-4 border-b border-gray-100">
                <h3 className="text-sm font-bold text-gray-900" style={{ fontFamily: "'Utendo', 'Arial', sans-serif" }}>
                  Contenido
                </h3>
              </div>
              <nav className="p-2 max-h-[calc(100vh-200px)] overflow-y-auto">
                {SECTIONS.map((s) => (
                  <button
                    key={s.id}
                    onClick={() => {
                      setActiveSection(s.id);
                      document.getElementById(s.id)?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-left transition-colors cursor-pointer mb-0.5 ${
                      activeSection === s.id
                        ? "bg-primary/10 text-primary font-medium"
                        : "text-gray-600 hover:bg-gray-50"
                    }`}
                  >
                    <i className={`${s.icon} text-base ${activeSection === s.id ? "text-primary" : "text-gray-400"}`} />
                    <span className="truncate">{s.title}</span>
                  </button>
                ))}
              </nav>
            </div>
          </aside>

          {/* Main content */}
          <main className="flex-1 min-w-0">
            <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
              {/* Print-only cover page */}
              <div className="hidden print:block p-16 text-center break-after-page">
                <div className="mb-8">
                  <div className="w-20 h-20 rounded-2xl bg-primary flex items-center justify-center mx-auto mb-6">
                    <i className="ri-book-open-line text-white text-4xl"></i>
                  </div>
                  <h1 className="text-4xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Utendo', 'Arial', sans-serif" }}>
                    Manual de Usuario
                  </h1>
                  <p className="text-xl text-gray-500 mb-2">Panel de Administracion</p>
                  <div className="w-24 h-1 bg-primary mx-auto mt-6 rounded-full"></div>
                </div>
                <p className="text-sm text-gray-400 mt-12">Version 2.0 &middot; Julio 2025</p>
              </div>

              {/* Section: Acceso */}
              <section id="acceso" className="p-6 md:p-10 border-b border-gray-100 break-inside-avoid">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <i className="ri-login-box-line text-primary text-xl"></i>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Utendo', 'Arial', sans-serif" }}>
                    1. Acceso al Sistema
                  </h2>
                </div>

                <div className="space-y-5 text-gray-700 text-sm leading-relaxed">
                  <p>
                    El panel de administracion se encuentra en <code className="bg-gray-100 px-2 py-0.5 rounded text-xs text-primary font-medium">/admin/login</code>.
                    Para acceder, necesita una cuenta de administrador registrada en el sistema.
                  </p>

                  <div className="bg-masmed-gray-50 border border-gray-200 rounded-lg p-4">
                    <h4 className="text-sm font-bold text-gray-900 mb-2">Credenciales por defecto</h4>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs">
                      <div>
                        <span className="text-gray-500">Correo:</span>
                        <code className="ml-2 bg-gray-100 px-2 py-0.5 rounded text-gray-800">admin@masmed.cl</code>
                      </div>
                      <div>
                        <span className="text-gray-500">Contrasena:</span>
                        <code className="ml-2 bg-gray-100 px-2 py-0.5 rounded text-gray-800">admin123</code>
                      </div>
                    </div>
                  </div>

                  <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                    <div className="flex items-start gap-3">
                      <i className="ri-information-line text-amber-600 text-lg mt-0.5"></i>
                      <div>
                        <h4 className="text-sm font-bold text-amber-800">Importante</h4>
                        <p className="text-xs text-amber-700 mt-1">
                          Cambie la contrasena por defecto despues del primer inicio de sesion por razones de seguridad.
                          Si no puede iniciar sesion, utilice el boton "Crear usuario admin por defecto" en la pantalla de login.
                        </p>
                      </div>
                    </div>
                  </div>

                  <h4 className="text-base font-bold text-gray-900 pt-2">Primer inicio de sesion</h4>
                  <ol className="list-decimal pl-5 space-y-2">
                    <li>Ingrese a <code className="bg-gray-100 px-1.5 py-0.5 rounded text-xs text-primary font-medium">/admin/login</code></li>
                    <li>Ingrese su correo electronico y contrasena</li>
                    <li>Haga clic en "Iniciar sesion"</li>
                    <li>Si las credenciales son correctas, sera redirigido al panel principal</li>
                  </ol>

                  <h4 className="text-base font-bold text-gray-900 pt-2">Cerrar sesion</h4>
                  <p>
                    Haga clic en el boton "Salir" ubicado en la esquina superior derecha del panel. Esto cerrara su sesion
                    y lo redirigira a la pantalla de inicio de sesion.
                  </p>
                </div>
              </section>

              {/* Section: Navegacion */}
              <section id="navegacion" className="p-6 md:p-10 border-b border-gray-100 break-inside-avoid">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <i className="ri-compass-3-line text-primary text-xl"></i>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Utendo', 'Arial', sans-serif" }}>
                    2. Navegacion General
                  </h2>
                </div>

                <div className="space-y-5 text-gray-700 text-sm leading-relaxed">
                  <p>
                    El panel de administracion esta organizado en pestanas. Cada pestana representa una seccion
                    del sitio web que puede administrar. Al hacer clic en una pestana, se muestran los registros
                    correspondientes en una tabla.
                  </p>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {[
                      { tab: "Inicio (pagina)", desc: "Configuracion de la pagina principal" },
                      { tab: "La Region (pagina)", desc: "Visibilidad de la seccion Territorio" },
                      { tab: "Noticias", desc: "Gestion de articulos y contenidos informativos" },
                      { tab: "Citas", desc: "Testimonios y frases destacadas del sitio" },
                      { tab: "Documentos", desc: "Archivos PDF y documentos descargables" },
                      { tab: "Equipo", desc: "Miembros del equipo y directiva" },
                    ].map((item) => (
                      <div key={item.tab} className="flex items-start gap-2.5 p-3 bg-masmed-gray-50 rounded-lg border border-gray-100">
                        <i className="ri-checkbox-circle-fill text-primary text-sm mt-0.5"></i>
                        <div>
                          <h5 className="text-sm font-bold text-gray-900">{item.tab}</h5>
                          <p className="text-xs text-gray-500 mt-0.5">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2">
                    {[
                      { tab: "Heroes", desc: "Banners principales de cada pagina" },
                      { tab: "Linea de Tiempo", desc: "Hitos y eventos cronologicos" },
                      { tab: "Footer", desc: "Informacion del pie de pagina" },
                      { tab: "Enlaces del Footer", desc: "Links en las columnas del footer" },
                      { tab: "Redes Sociales", desc: "Enlaces a plataformas sociales" },
                      { tab: "Comunas", desc: "Datos geograficos y estadisticos por comuna" },
                    ].map((item) => (
                      <div key={item.tab} className="flex items-start gap-2.5 p-3 bg-masmed-gray-50 rounded-lg border border-gray-100">
                        <i className="ri-checkbox-circle-fill text-primary text-sm mt-0.5"></i>
                        <div>
                          <h5 className="text-sm font-bold text-gray-900">{item.tab}</h5>
                          <p className="text-xs text-gray-500 mt-0.5">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2">
                    {[
                      { tab: "Indicadores", desc: "Cifras y metricas del proyecto" },
                      { tab: "Vision y Mision", desc: "Declaraciones institucionales" },
                      { tab: "Objetivos", desc: "Metas y propositos del proyecto" },
                      { tab: "Especialistas", desc: "Profesionales y colaboradores" },
                      { tab: "Filtros de Evidencias", desc: "Categorias para filtrar evidencias" },
                      { tab: "Etapas del Estudio", desc: "Fases del proyecto de investigacion" },
                    ].map((item) => (
                      <div key={item.tab} className="flex items-start gap-2.5 p-3 bg-masmed-gray-50 rounded-lg border border-gray-100">
                        <i className="ri-checkbox-circle-fill text-primary text-sm mt-0.5"></i>
                        <div>
                          <h5 className="text-sm font-bold text-gray-900">{item.tab}</h5>
                          <p className="text-xs text-gray-500 mt-0.5">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="bg-masmed-gray-50 border border-gray-200 rounded-lg p-4">
                    <h4 className="text-sm font-bold text-gray-900 mb-2">Elementos comunes del panel</h4>
                    <ul className="space-y-2 text-xs">
                      <li className="flex items-start gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0"></span>
                        <span><strong>Barra superior:</strong> Muestra el nombre del panel, acceso al sitio publico y boton de cierre de sesion.</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0"></span>
                        <span><strong>Pestanas:</strong> Permiten navegar entre las distintas secciones. Cada pestana muestra la cantidad de registros.</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0"></span>
                        <span><strong>Barra de busqueda:</strong> Filtra registros en tiempo real dentro de la pestana activa.</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0"></span>
                        <span><strong>Boton "Nuevo":</strong> Crea un nuevo registro en la seccion actual.</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0"></span>
                        <span><strong>Boton de recarga:</strong> Actualiza los datos desde la base de datos.</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>

              {/* Section: Operaciones */}
              <section id="operaciones" className="p-6 md:p-10 border-b border-gray-100 break-inside-avoid">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <i className="ri-tools-line text-primary text-xl"></i>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Utendo', 'Arial', sans-serif" }}>
                    3. Operaciones Basicas
                  </h2>
                </div>

                <div className="space-y-6 text-gray-700 text-sm leading-relaxed">
                  {/* Crear */}
                  <div>
                    <h4 className="text-base font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-md bg-emerald-100 text-emerald-700 flex items-center justify-center text-xs font-bold">+</span>
                      Crear un registro
                    </h4>
                    <ol className="list-decimal pl-5 space-y-1.5 text-xs">
                      <li>Seleccione la pestana correspondiente al tipo de contenido</li>
                      <li>Haga clic en el boton <strong>"Nuevo"</strong> (color naranja, esquina superior derecha)</li>
                      <li>Complete los campos del formulario que aparece a la izquierda</li>
                      <li>Observe la vista previa en tiempo real en el panel derecho</li>
                      <li>Haga clic en <strong>"Guardar"</strong> para almacenar el registro</li>
                    </ol>
                  </div>

                  {/* Editar */}
                  <div>
                    <h4 className="text-base font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-md bg-amber-100 text-amber-700 flex items-center justify-center text-xs"><i className="ri-pencil-line"></i></span>
                      Editar un registro
                    </h4>
                    <ol className="list-decimal pl-5 space-y-1.5 text-xs">
                      <li>Ubique el registro en la tabla</li>
                      <li>Haga clic en el icono de lapiz <i className="ri-pencil-line text-gray-400"></i> en la columna "Acciones"</li>
                      <li>Modifique los campos necesarios en el formulario</li>
                      <li>Haga clic en <strong>"Guardar"</strong> para aplicar los cambios</li>
                    </ol>
                    <div className="mt-2 bg-masmed-gray-50 border border-gray-200 rounded-lg p-3">
                      <p className="text-xs text-gray-600">
                        <i className="ri-information-line text-primary mr-1"></i>
                        Si abre el formulario por error, puede hacer clic en <strong>"Cancelar"</strong> para cerrarlo.
                        Si realizo cambios y quiere descartarlos, el sistema le preguntara antes de cerrar.
                      </p>
                    </div>
                  </div>

                  {/* Eliminar */}
                  <div>
                    <h4 className="text-base font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-md bg-red-100 text-red-600 flex items-center justify-center text-xs"><i className="ri-delete-bin-line"></i></span>
                      Eliminar un registro
                    </h4>
                    <ol className="list-decimal pl-5 space-y-1.5 text-xs">
                      <li>Ubique el registro en la tabla</li>
                      <li>Haga clic en el icono de papelera <i className="ri-delete-bin-line text-gray-400"></i> en la columna "Acciones"</li>
                      <li>Confirme la eliminacion en el cuadro de dialogo</li>
                    </ol>
                    <div className="mt-2 bg-red-50 border border-red-200 rounded-lg p-3">
                      <p className="text-xs text-red-700">
                        <i className="ri-error-warning-line text-red-500 mr-1"></i>
                        <strong>Precaucion:</strong> La eliminacion es permanente y no se puede deshacer.
                        Verifique que esta eliminando el registro correcto antes de confirmar.
                      </p>
                    </div>
                  </div>

                  {/* Reordenar */}
                  <div>
                    <h4 className="text-base font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-md bg-secondary/10 text-secondary flex items-center justify-center text-xs"><i className="ri-draggable"></i></span>
                      Reordenar elementos
                    </h4>
                    <p className="text-xs mb-2">
                      Algunas secciones permiten reordenar elementos arrastrando y soltando (linea de tiempo, enlaces del footer, comunas,
                      indicadores, vision/mision, objetivos, especialistas, redes sociales, filtros de evidencias, etapas del estudio).
                    </p>
                    <ol className="list-decimal pl-5 space-y-1.5 text-xs">
                      <li>Ubique el icono de arrastre <i className="ri-draggable text-gray-400"></i> al inicio de cada fila</li>
                      <li>Haga clic sostenido y arrastre la fila a la posicion deseada</li>
                      <li>Aparecera un mensaje indicando que el orden ha cambiado</li>
                      <li>Haga clic en <strong>"Guardar orden"</strong> para confirmar los cambios</li>
                    </ol>
                  </div>

                  {/* Subir archivos */}
                  <div>
                    <h4 className="text-base font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-md bg-secondary/10 text-secondary flex items-center justify-center text-xs"><i className="ri-upload-2-line"></i></span>
                      Subida de archivos
                    </h4>
                    <div className="space-y-4 text-xs">
                      <div className="bg-masmed-gray-50 border border-gray-200 rounded-lg p-3">
                        <h5 className="font-bold text-gray-900 mb-1">Imagenes</h5>
                        <p className="text-gray-600 mb-3">
                          Formatos aceptados: JPG, PNG, GIF, WebP. Las imagenes se suben mediante link publico de Google Drive.
                          Para que el link funcione, el archivo en Drive debe tener acceso "Cualquier persona con el enlace".
                        </p>

                        {/* Tabla de especificaciones por sección */}
                        <div className="overflow-x-auto">
                          <table className="w-full text-xs border-collapse">
                            <thead>
                              <tr className="bg-gray-100">
                                <th className="text-left px-3 py-2 font-bold text-gray-700 border border-gray-200">Sección</th>
                                <th className="text-left px-3 py-2 font-bold text-gray-700 border border-gray-200">Campo</th>
                                <th className="text-center px-3 py-2 font-bold text-gray-700 border border-gray-200">Proporción</th>
                                <th className="text-center px-3 py-2 font-bold text-gray-700 border border-gray-200">Mínimo</th>
                                <th className="text-center px-3 py-2 font-bold text-gray-700 border border-gray-200">Recomendado</th>
                                <th className="text-center px-3 py-2 font-bold text-gray-700 border border-gray-200">Máximo</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="bg-white hover:bg-gray-50">
                                <td className="px-3 py-2 font-medium text-gray-900 border border-gray-200">Heroes (Banners)</td>
                                <td className="px-3 py-2 text-gray-600 border border-gray-200">background_image</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">16:9</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">1920 × 1080</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">2560 × 1440</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">3840 × 2160</td>
                              </tr>
                              <tr className="bg-white hover:bg-gray-50">
                                <td className="px-3 py-2 font-medium text-gray-900 border border-gray-200">Noticias</td>
                                <td className="px-3 py-2 text-gray-600 border border-gray-200">imagen</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">16:9</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">800 × 450</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">1200 × 675</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">1920 × 1080</td>
                              </tr>
                              <tr className="bg-white hover:bg-gray-50">
                                <td className="px-3 py-2 font-medium text-gray-900 border border-gray-200">Comunas</td>
                                <td className="px-3 py-2 text-gray-600 border border-gray-200">imagen</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">16:9</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">800 × 450</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">1200 × 675</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">1920 × 1080</td>
                              </tr>
                              <tr className="bg-white hover:bg-gray-50">
                                <td className="px-3 py-2 font-medium text-gray-900 border border-gray-200">Equipo</td>
                                <td className="px-3 py-2 text-gray-600 border border-gray-200">foto</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">1:1 (cuadrada)</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">400 × 400</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">800 × 800</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">1200 × 1200</td>
                              </tr>
                              <tr className="bg-white hover:bg-gray-50">
                                <td className="px-3 py-2 font-medium text-gray-900 border border-gray-200">Especialistas</td>
                                <td className="px-3 py-2 text-gray-600 border border-gray-200">foto</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">1:1 (cuadrada)</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">400 × 400</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">800 × 800</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">1200 × 1200</td>
                              </tr>
                              <tr className="bg-white hover:bg-gray-50">
                                <td className="px-3 py-2 font-medium text-gray-900 border border-gray-200">Citas (Testimonios)</td>
                                <td className="px-3 py-2 text-gray-600 border border-gray-200">avatar</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">1:1 (cuadrada)</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">200 × 200</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">400 × 400</td>
                                <td className="text-center px-3 py-2 text-gray-600 border border-gray-200">800 × 800</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="mt-3 bg-amber-50 border border-amber-200 rounded-lg p-3">
                          <div className="flex items-start gap-2">
                            <i className="ri-information-line text-amber-600 text-sm mt-0.5"></i>
                            <div className="text-xs text-amber-700">
                              <p className="font-bold mb-1">Recomendaciones importantes:</p>
                              <ul className="list-disc pl-4 space-y-0.5">
                                <li>Las imagenes de heroes (banners) deben tener prioridad a resoluciones altas porque ocupan todo el ancho de la pantalla.</li>
                                <li>Las fotos de equipo y especialistas deben tener el rostro centrado y en la parte superior del encuadre.</li>
                                <li>El fondo de las fotos de equipo debe ser neutro y uniforme para mantener consistencia visual.</li>
                                <li>Para noticias y comunas, evite imagenes con texto incrustado; el texto se superpone desde el codigo.</li>
                                <li>El tamano maximo de archivo es <strong>20 MB</strong>. Si la imagen pesa mas, comprimala antes de subir.</li>
                                <li>Si la imagen no cumple con la proporcion indicada, se recortara automaticamente para ajustarse, lo que puede cortar partes importantes.</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bg-masmed-gray-50 border border-gray-200 rounded-lg p-3">
                        <h5 className="font-bold text-gray-900 mb-1">Documentos PDF</h5>
                        <p className="text-gray-600">
                          Solo se aceptan archivos PDF. Tamano maximo: 20 MB.
                          Disponible unicamente en la seccion de Documentos.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Busqueda */}
                  <div>
                    <h4 className="text-base font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <span className="w-6 h-6 rounded-md bg-masmed-gray-100 text-gray-600 flex items-center justify-center text-xs"><i className="ri-search-line"></i></span>
                      Buscar registros
                    </h4>
                    <p className="text-xs">
                      Use la barra de busqueda para filtrar registros por cualquier campo.
                      La busqueda es en tiempo real: los resultados se actualizan mientras escribe.
                      El contador a la derecha muestra cuantos registros coinciden del total.
                    </p>
                  </div>
                </div>
              </section>

              {/* Sections for each tab - simplified with table of fields */}
              {[
                {
                  id: "noticias",
                  num: "4",
                  title: "Noticias",
                  icon: "ri-newspaper-line",
                  desc: "Gestione los articulos y contenidos informativos que aparecen en la seccion de noticias del sitio web.",
                  groups: [
                    { label: "Basico", fields: ["titulo", "subtitulo", "fecha", "comuna", "categoria", "segmento"] },
                    { label: "Contenido", fields: ["extracto (texto largo)"] },
                    { label: "Media", fields: ["imagen (subida de archivo)"] },
                  ],
                },
                {
                  id: "citas",
                  num: "5",
                  title: "Citas y Testimonios",
                  icon: "ri-double-quotes-l",
                  desc: "Administre las citas, testimonios y frases destacadas que aparecen en la seccion Miradas del sitio.",
                  groups: [
                    { label: "Basico", fields: ["texto", "autor", "cargo", "sector", "fecha"] },
                    { label: "Media", fields: ["avatar (imagen)", "likes (numero)"] },
                  ],
                },
                {
                  id: "documentos",
                  num: "6",
                  title: "Documentos",
                  icon: "ri-file-list-line",
                  desc: "Gestione los documentos PDF y archivos descargables disponibles en la seccion de documentos.",
                  groups: [
                    { label: "Basico", fields: ["titulo", "categoria", "ano", "mes", "tipo", "tamano"] },
                    { label: "Contenido", fields: ["descripcion (texto largo)"] },
                    { label: "Archivo", fields: ["archivo_url (PDF, subida de archivo)"] },
                  ],
                },
                {
                  id: "equipo",
                  num: "7",
                  title: "Equipo",
                  icon: "ri-team-line",
                  desc: "Administre los miembros del equipo y directiva que aparecen en el sitio web.",
                  groups: [
                    { label: "Basico", fields: ["nombre", "cargo", "direccion", "email", "telefono"] },
                    { label: "Media", fields: ["foto (imagen)"] },
                  ],
                },
                {
                  id: "heroes",
                  num: "8",
                  title: "Heroes (Banners)",
                  icon: "ri-image-line",
                  desc: "Configure los banners principales (hero) que aparecen en la parte superior de cada pagina del sitio.",
                  groups: [
                    { label: "Basico", fields: ["page (pagina asociada)", "tagline", "title", "subtitle", "description", "cta_text", "cta_link"] },
                    { label: "Media", fields: ["background_image (imagen de fondo)", "overlay_gradient"] },
                  ],
                },
                {
                  id: "timeline",
                  num: "9",
                  title: "Linea de Tiempo",
                  icon: "ri-time-line",
                  desc: "Gestione los hitos y eventos que aparecen en la linea de tiempo cronologica del proyecto.",
                  groups: [
                    { label: "Basico", fields: ["orden (numero)", "titulo", "descripcion", "fecha"] },
                    { label: "Estado", fields: ["estado_tipo (texto)", "estado_color (selector de color)"] },
                  ],
                  reorderable: true,
                },
                {
                  id: "footer",
                  num: "10",
                  title: "Footer",
                  icon: "ri-layout-bottom-line",
                  desc: "Configure la informacion que aparece en el pie de pagina de todo el sitio web.",
                  groups: [
                    { label: "Contenido", fields: ["descripcion", "direccion", "email", "web", "rut", "telefono", "copyright"] },
                  ],
                },
                {
                  id: "footer_links",
                  num: "11",
                  title: "Enlaces del Footer",
                  icon: "ri-links-line",
                  desc: "Gestione los enlaces que aparecen en las columnas del pie de pagina: Sitios de interes y Mapa del sitio.",
                  groups: [
                    { label: "Basico", fields: ["orden (numero)", "label (texto del enlace)", "url (direccion web)", "seccion (Sitios de interes / Mapa del sitio)", "activo (si/no)"] },
                  ],
                  reorderable: true,
                },
                {
                  id: "redes",
                  num: "12",
                  title: "Redes Sociales",
                  icon: "ri-share-line",
                  desc: "Administre los enlaces a redes sociales que aparecen en el sitio.",
                  groups: [
                    { label: "Basico", fields: ["orden (numero)", "nombre", "url", "icono (clase Remix Icon)", "color_class"] },
                  ],
                  reorderable: true,
                },
                {
                  id: "comunas",
                  num: "13",
                  title: "Comunas",
                  icon: "ri-map-pin-line",
                  desc: "Gestione los datos geograficos y estadisticos de cada comuna en el territorio.",
                  groups: [
                    { label: "Basico", fields: ["id (texto)", "nombre", "habitantes (numero)", "especialistas (numero)", "centros_medicos (numero)", "orden (numero)"] },
                    { label: "Mapa", fields: ["dot_cx (coordenada X)", "dot_cy (coordenada Y)", "path_indices"] },
                    { label: "Media", fields: ["imagen (subida de archivo)"] },
                  ],
                  reorderable: true,
                },
                {
                  id: "indicadores",
                  num: "14",
                  title: "Indicadores",
                  icon: "ri-pie-chart-line",
                  desc: "Administre las cifras y metricas que se muestran en la seccion de indicadores del proyecto.",
                  groups: [
                    { label: "Basico", fields: ["orden (numero)", "valor (numero decimal)", "titulo", "subtitulo", "posicion"] },
                  ],
                  reorderable: true,
                },
                {
                  id: "vision",
                  num: "15",
                  title: "Vision y Mision",
                  icon: "ri-eye-line",
                  desc: "Gestione las declaraciones de vision y mision institucional del proyecto.",
                  groups: [
                    { label: "Basico", fields: ["orden (numero)", "tipo (vision/mision)", "titulo", "descripcion", "icono (clase Remix Icon)"] },
                  ],
                  reorderable: true,
                },
                {
                  id: "objetivos",
                  num: "16",
                  title: "Objetivos",
                  icon: "ri-flag-line",
                  desc: "Administre los objetivos y metas del proyecto.",
                  groups: [
                    { label: "Basico", fields: ["orden (numero)", "titulo", "descripcion"] },
                  ],
                  reorderable: true,
                },
                {
                  id: "especialistas",
                  num: "17",
                  title: "Especialistas",
                  icon: "ri-user-star-line",
                  desc: "Gestione los profesionales y colaboradores que aparecen en el sitio.",
                  groups: [
                    { label: "Basico", fields: ["orden (numero)", "nombre", "cargo", "institucion", "email", "telefono"] },
                    { label: "Media", fields: ["foto (imagen)"] },
                  ],
                  reorderable: true,
                },
                {
                  id: "evidencias",
                  num: "18",
                  title: "Filtros de Evidencias",
                  icon: "ri-filter-3-line",
                  desc: "Administre las categorias y opciones de filtro que aparecen en la seccion de Evidencias del sitio web.",
                  groups: [
                    { label: "Basico", fields: ["orden (numero)", "nombre", "tipo (categoria/opcion)", "activo (si/no)"] },
                  ],
                  reorderable: true,
                },
                {
                  id: "etapas",
                  num: "19",
                  title: "Etapas del Estudio",
                  icon: "ri-stack-line",
                  desc: "Gestione las etapas o fases del estudio que se muestran en la pagina MasMed del proyecto.",
                  groups: [
                    { label: "Basico", fields: ["orden (numero)", "titulo", "descripcion"] },
                  ],
                  reorderable: true,
                },
                {
                  id: "paginas",
                  num: "20",
                  title: "Paginas: Inicio y La Region",
                  icon: "ri-pages-line",
                  desc: "Configure la visibilidad de secciones en las paginas principales del sitio.",
                  groups: [
                    { label: "Inicio", fields: ["Mostrar seccion Territorio en Inicio (si/no)", "Mostrar u ocultar secciones"] },
                    { label: "La Region", fields: ["Mostrar seccion Territorio en La Region (si/no)"] },
                  ],
                },
              ].map((section) => (
                <section key={section.id} id={section.id} className="p-6 md:p-10 border-b border-gray-100 break-inside-avoid">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                      <i className={`${section.icon} text-primary text-xl`}></i>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Utendo', 'Arial', sans-serif" }}>
                      {section.num}. {section.title}
                    </h2>
                  </div>

                  <div className="space-y-4 text-gray-700 text-sm leading-relaxed">
                    <p>{section.desc}</p>

                    {section.reorderable && (
                      <div className="bg-secondary/5 border border-secondary/20 rounded-lg p-3 flex items-start gap-2.5">
                        <i className="ri-drag-move-line text-secondary text-lg mt-0.5"></i>
                        <p className="text-xs text-gray-700">
                          <strong className="text-secondary">Ordenable:</strong> Esta seccion permite reordenar elementos
                          arrastrando las filas en la tabla. Recuerde hacer clic en "Guardar orden" despues de reordenar.
                        </p>
                      </div>
                    )}

                    <div>
                      <h4 className="text-sm font-bold text-gray-900 mb-3">Campos disponibles</h4>
                      {section.groups.map((group) => (
                        <div key={group.label} className="mb-3 last:mb-0">
                          <h5 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">{group.label}</h5>
                          <div className="flex flex-wrap gap-1.5">
                            {group.fields.map((field) => (
                              <span
                                key={field}
                                className="inline-block px-2.5 py-1 bg-masmed-gray-50 border border-gray-200 rounded-md text-xs text-gray-700 font-mono"
                              >
                                {field}
                              </span>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Special note for icon fields */}
                    {(section.id === "redes" || section.id === "vision") && (
                      <div className="bg-masmed-gray-50 border border-gray-200 rounded-lg p-3">
                        <h5 className="text-xs font-bold text-gray-900 mb-1">Iconos disponibles (Remix Icon)</h5>
                        <p className="text-xs text-gray-600">
                          Utilice clases de <a href="https://remixicon.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Remix Icon</a> como
                          <code className="mx-1 bg-gray-100 px-1.5 py-0.5 rounded text-xs">ri-facebook-fill</code>,
                          <code className="mx-1 bg-gray-100 px-1.5 py-0.5 rounded text-xs">ri-instagram-line</code>,
                          <code className="mx-1 bg-gray-100 px-1.5 py-0.5 rounded text-xs">ri-youtube-fill</code>,
                          <code className="mx-1 bg-gray-100 px-1.5 py-0.5 rounded text-xs">ri-linkedin-fill</code>,
                          <code className="mx-1 bg-gray-100 px-1.5 py-0.5 rounded text-xs">ri-twitter-x-fill</code>, etc.
                        </p>
                      </div>
                    )}
                  </div>
                </section>
              ))}

              {/* Section: Problemas */}
              <section id="problemas" className="p-6 md:p-10">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <i className="ri-question-line text-primary text-xl"></i>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Utendo', 'Arial', sans-serif" }}>
                    21. Solucion de Problemas
                  </h2>
                </div>

                <div className="space-y-5 text-gray-700 text-sm leading-relaxed">
                  <div className="bg-masmed-gray-50 border border-gray-200 rounded-lg p-4">
                    <h4 className="text-sm font-bold text-gray-900 mb-1">No puedo iniciar sesion</h4>
                    <ul className="list-disc pl-5 space-y-1 text-xs mt-2">
                      <li>Verifique que el correo y contrasena sean correctos</li>
                      <li>Utilice el boton "Crear usuario admin por defecto" en la pantalla de login</li>
                      <li>Si el problema persiste, contacte al administrador del sistema</li>
                    </ul>
                  </div>

                  <div className="bg-masmed-gray-50 border border-gray-200 rounded-lg p-4">
                    <h4 className="text-sm font-bold text-gray-900 mb-1">Los cambios no se reflejan en el sitio</h4>
                    <ul className="list-disc pl-5 space-y-1 text-xs mt-2">
                      <li>Asegurese de haber hecho clic en "Guardar" despues de editar</li>
                      <li>Espere unos segundos: los datos se sincronizan en tiempo real</li>
                      <li>Haga clic en el boton de recarga <i className="ri-refresh-line text-gray-400"></i> para forzar la actualizacion</li>
                      <li>Si es un hero (banner), verifique que el campo "page" coincida con la pagina correcta</li>
                    </ul>
                  </div>

                  <div className="bg-masmed-gray-50 border border-gray-200 rounded-lg p-4">
                    <h4 className="text-sm font-bold text-gray-900 mb-1">Error al subir una imagen o PDF</h4>
                    <ul className="list-disc pl-5 space-y-1 text-xs mt-2">
                      <li>Verifique que el formato sea correcto (imagen: JPG/PNG/GIF/WebP, documento: PDF)</li>
                      <li>Asegurese de que el archivo no supere los 20 MB</li>
                      <li>Intente con un archivo de menor tamano</li>
                    </ul>
                  </div>

                  <div className="bg-masmed-gray-50 border border-gray-200 rounded-lg p-4">
                    <h4 className="text-sm font-bold text-gray-900 mb-1">Error de conexion con la base de datos</h4>
                    <ul className="list-disc pl-5 space-y-1 text-xs mt-2">
                      <li>Aparecera un mensaje rojo en la parte superior del panel</li>
                      <li>Haga clic en "Reintentar" para volver a conectarse</li>
                      <li>Verifique su conexion a internet</li>
                      <li>Si el problema persiste, el servicio puede estar en mantenimiento</li>
                    </ul>
                  </div>

                  <div className="bg-masmed-gray-50 border border-gray-200 rounded-lg p-4">
                    <h4 className="text-sm font-bold text-gray-900 mb-1">Los enlaces del footer no aparecen en la columna correcta</h4>
                    <ul className="list-disc pl-5 space-y-1 text-xs mt-2">
                      <li>Verifique el campo "seccion" de cada enlace en la pestana "Enlaces del Footer"</li>
                      <li>"Sitios de interes" corresponde a la columna izquierda del footer</li>
                      <li>"Mapa del sitio" corresponde a la columna central del footer</li>
                      <li>Asegurese de que el enlace este marcado como "Activo"</li>
                    </ul>
                  </div>

                  <div className="bg-masmed-gray-50 border border-gray-200 rounded-lg p-4">
                    <h4 className="text-sm font-bold text-gray-900 mb-1">No veo la seccion Territorio en una pagina</h4>
                    <ul className="list-disc pl-5 space-y-1 text-xs mt-2">
                      <li>Vaya a la pestana "La Region (pagina)" en el panel</li>
                      <li>Active o desactive la casilla "Mostrar seccion Territorio" segun necesite</li>
                      <li>Haga clic en "Guardar" para aplicar el cambio</li>
                      <li>Lo mismo aplica para la seccion Territorio en la pagina de Inicio</li>
                    </ul>
                  </div>

                  <div className="bg-masmed-gray-50 border border-gray-200 rounded-lg p-4">
                    <h4 className="text-sm font-bold text-gray-900 mb-1">El orden de los elementos no se guarda</h4>
                    <ul className="list-disc pl-5 space-y-1 text-xs mt-2">
                      <li>Despues de arrastrar las filas, debe hacer clic en el boton "Guardar orden"</li>
                      <li>El boton aparece en un banner naranja debajo de la tabla</li>
                      <li>Si el banner no aparece, es posible que el orden ya este guardado</li>
                    </ul>
                  </div>
                </div>
              </section>

              {/* Footer */}
              <div className="p-6 md:p-10 border-t border-gray-100 bg-masmed-gray-50 print:hidden">
                <p className="text-xs text-gray-500 text-center">
                  Manual de Usuario &middot; Panel de Administracion &middot; Version 2.0 &middot; Julio 2025
                </p>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Print styles */}
      <style>{`
        @media print {
          body { background: white !important; }
          .print\\:hidden { display: none !important; }
          .print\\:block { display: block !important; }
          @page { margin: 1.5cm; size: A4; }
        }
      `}</style>
    </div>
  );
}